import { useEffect, useRef } from 'react';

export const useInterval = (callback: () => void, delay: number, needsRetry: boolean): void => {
  const savedCallback = useRef<() => void>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current?.();
    }

    let id: ReturnType<typeof setInterval> | null = null;

    if (needsRetry) {
      id = setInterval(tick, delay);
    }

    return () => {
      if (id !== null) {
        clearInterval(id);
      }
    };
  }, [delay, needsRetry]);
};
